module.exports = __webpack_public_path__ + "static/img/4.ba0fc0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/zh/4.png
// module id = I/e5
// module chunks = 0